import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerForgotPasswordFormResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      form: {
        ForgotPasswordForm: {
          cancel: 'Cancel',
          emailLabel: 'Email',
          infoText:
            'Enter your email address here. After you have clicked "$t(form.ForgotPasswordForm.sendEmail)", you will receive an email with a link to reset your password.',
          noEmailAddressEnteredText: 'No email address was entered.',
          sendEmail: 'Send email',
          sendingEmailFailedText:
            'A problem while sending your email occurred.',
          successNotification: {
            title: 'Successfully sent the email',
            message: 'Open the email and follow its instructions.'
          },
          title: 'Forgot password'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
